import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../../config/axions.config';
import Swal from 'sweetalert2';
import { MdOutlineFileUpload } from "react-icons/md";
import { MdDelete } from "react-icons/md";

const EditTutor = () => {

  let navigate = useNavigate();
  let location = useLocation();
  let data = location.state
  const [activeTab, setActiveTab] = useState(0);
  const tabClick = (index) => {
    setActiveTab(index);
  };

  // new Staff 
  const [firstname, setFirstname] = useState(data?.firstname);
  const [lastname, setLastname] = useState(data?.lastname);
  const [gender, setGender] = useState(data?.gender);
  const [email, setEmail] = useState(data?.email);
  const [mobile, setMobile] = useState(data?.mobile);
  const [staff_type, setStaff_type] = useState(data?.staff_type);
  const [dob, setDob] = useState(data?.dob.split("T")[0]);
  const [address, setAddress] = useState(data?.address);
  const [experties, setExperties] = useState(data?.experties);
  const [joining_date, setjoining_date] = useState(data?.joining_date.split("T")[0]);
  const [is_active, setIs_active] = useState(data?.is_active);
  const [Photo, setPhoto] = useState({ Bytes: '', filename: '' });
  const [aadhar, setAadhar] = useState({ Bytes: '', filename: '' });
  const [pan, setPan] = useState({ Bytes: '', filename: '' });
  const [Cheque, setCheque] = useState({ Bytes: '', filename: '' });


  // staff detailstable 
  const [bank_name, setBank_name] = useState(data?.staffdetails.bank_name);
  const [account_no, setAccount_no] = useState(data?.staffdetails.account_no);
  const [account_holder_name, setAccount_holder_name] = useState(data?.staffdetails.account_holder_name);
  const [accountType, setAccountType] = useState(data?.staffdetails.account_type);
  const [ifsc_code, setIfsc_code] = useState(data?.staffdetails.ifsc_code);
  const [type_of_salary, setType_of_salary] = useState(data?.staffdetails.type_of_salary);

  const inputRefPhoto = useRef();
  const inputRefAdhaar = useRef();
  const inputRefPan = useRef();
  const inputRefCheque = useRef();
  const [selectedPhoto, setSelectedPhoto] = useState({ Bytes: "", filename: "" });
  const [selectedAdhaar, setSelectedAdhaar] = useState({ Bytes: "", filename: "" });
  const [selectedPan, setSelectedPan] = useState({ Bytes: "", filename: "" });
  const [selectedCheque, setSelectedCheque] = useState({ Bytes: "", filename: "" });
  const [course_id, setCourse_id] = useState('')
  const [courseList, setCourseList] = useState([])
  const [tutorActive,setTutorActive] = useState(true)

  async function updateStaffTabOne() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this?!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        let responce = await api.patch(`staff/${data._id}`, { firstname, lastname, gender, email, mobile, staff_type, dob, address, experties, joining_date, is_active})
        if (responce.data.status) {
          toast.success(responce.data.message);
        } else {
          toast.error(responce.data.message);
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }

  async function updateStaffTabTwo() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this?!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        let responce = await api.patch(`staff/details/${data.staffdetails._id}`, { bank_name, account_no, account_holder_name, accountType, ifsc_code, type_of_salary})
        if (responce.data.status) {
          toast.success(responce.data.message);
        } else {
          toast.error(responce.data.message);
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }

  async function getCourseList() {
    try{
      let responce = await api.get("course")
      if(responce?.data.status){
        setCourseList(responce.data.data.courses);
      }else{
        toast.error(responce.data.message)
      }
    }catch(error){
      console.log(error);
    }
  }

  // For Photo seelection
  const handleOnchange = (event) => {
    if (event.target.files && event.target.files.length > 0){
        setSelectedPhoto(event.target.files[0]);
    }
  }

  const onChooseFile = () => {
    inputRefPhoto.current.click();
  }

  const removeFile = () => {
    setSelectedPhoto(null)
  }

  // For Adhaar selection
  const handleOnchangeAdhaar = (event) => {
    if (event.target.files && event.target.files.length > 0){
        setSelectedAdhaar(event.target.files[0]);
    }
  }

  const onChooseAdhaar = () => {
    inputRefAdhaar.current.click();
  }

  const removeAdhaar = () => {
    setSelectedAdhaar(null)
  }

  // For Pan selection
  const handleOnchangePan = (event) => {
    if (event.target.files && event.target.files.length > 0){
        setSelectedPan(event.target.files[0]);
    }
  }

  const onChoosePan = () => {
    inputRefPan.current.click();
  }

  const removePan = () => {
    setSelectedPan(null)
  }

  // For Cheque selection
  const handleOnchangeCheque = (event) => {
    if (event.target.files && event.target.files.length > 0){
        setSelectedCheque(event.target.files[0]);
    }
  }

  const onChooseCheque = () => {
    inputRefCheque.current.click();
  }

  const removeCheque = () => {
    setSelectedCheque(null)
  }

  useEffect(()=>{
        getCourseList();
    },[])
  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
          <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
              <nav className="sm:hidden" aria-label="Back">
                <div className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                  <svg className="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Back
                </div>
              </nav>
    
              <nav className="hidden sm:flex" aria-label="Breadcrumb">
                <ol className="flex items-center space-x-4">
                  <li>
                    <div>
                      <div className="text-gray-400 hover:text-gray-500">
                        <svg className="flex-shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                        </svg>
                        <span className="sr-only">Home</span>
                      </div>
                    </div>
                  </li>
    
                  <li>
                    <div className="flex items-center">
                      <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                      </svg>
                      <div className="ml-4 text-sm text-gray-500 hover:text-gray-700" onClick={()=>navigate('/dashboard/staff/')}>
                        Staff
                      </div>
                    </div>
                  </li>
    
                  <li>
                    <div className="flex items-center">
                      <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                      </svg>
                      <div className="ml-3 text-sm text-gray-500 hover:text-gray-700" aria-current="page">
                        Edit Staff
                      </div>
                    </div>
                  </li>
                </ol>
              </nav>
    
              <hr className="my-5 border-gray-300" />
    
              <div className="lg:flex lg:items-center lg:space-x-8">
                <div className="lg:flex-1 lg:min-w-0">
                  <h1 className="text-2xl font-semibold text-primary-600">
                    Staff
                  </h1>
                  <div className="mt-2 md:mt-3 sm:flex sm:items-center sm:space-x-6">
                    <div className="flex items-center space-x-3">
                      <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                        <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                        <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                      </svg>
                      <span className="text-gray-600">
                        Staff Id
                      </span>
                    </div>
    
                    <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                      <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                        <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                        <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                        <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                        <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                      </svg>
                      <span className="text-gray-600">
                        Started 00-00-00
                      </span>
                    </div>
                  </div>
                </div>
    
                <div className="flex items-center mt-5 ml-auto space-x-6 lg:justify-end lg:mt-0 lg:flex-shrink-0">
                  <div className="flex items-center space-x-2">
                    <label htmlFor="">
                      Staff Status
                    </label>
                    <div className="toggle-switch">
                      <input type="checkbox" id="toggleSwitch" checked={tutorActive} onChange={()=>setTutorActive(!tutorActive)} value={true} />
                      <label htmlFor="toggleSwitch"></label>
                    </div>
                  </div>
                </div>
              </div>
    
              <div className="mt-6 space-y-6">
                <div className="bg-white rounded-lg shadow">
                  <div className="px-4 sm:px-6">
                    <div className='flex justify-between items-center'>
                    <div className='flex items-center -ml-2'>
                      <div title="Back" className="btn-circle" aria-label="Back" data-microtip-position="top" data-target="tooltip" role="button" onClick={()=>navigate('/dashboard/staff/')}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                        </svg>
                        </div>
                        <h2 className="ml-2 text-lg font-medium leading-6 text-gray-900">
                        Edit Staff
                        </h2>
                      </div>
    
                      <div className="px-4 sm:px-6 items-end">
                        <nav className="flex -mb-px space-x-8" aria-label="Tabs">
                          <div title="" aria-current="page" onClick={() => tabClick(0)} className={activeTab === 0 ? 'active text-primary-600 border-b-2 border-primary-600' : ''}>
                          <div className='px-1 py-5 text-sm font-medium border-primary-600 hover:cursor-pointer'>Step 1</div>
                          </div>
                          <div title="" onClick={() => tabClick(1)} className={`items-center${activeTab === 1 ? 'active text-primary-600 border-b-2 border-primary-600' : ''}`}>
                            <div className='px-1 py-5 text-sm font-medium items-center hover:cursor-pointer'>Step 2</div>
                          </div>
                        </nav>
                      </div>
                    </div>
                  </div>
    
                  <div className="px-4 py-5 border-t border-gray-300 sm:px-6">
                    {
                      activeTab === 0 && 
                      <div>
                        <form action={(e)=>updateStaffTabOne(e)}>
                          <div className="grid grid-cols-3 sm:grid-cols-3 gap-x-5 gap-y-4">
                            <div className="col-span-1 sm:col-span-3 md:col-span-1">
                              <label htmlFor="">
                                First Name <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="text" value={firstname} onChange={(e)=>setFirstname(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-3 md:col-span-1">
                              <label htmlFor="">
                                Last Name <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="text" value={lastname} onChange={(e)=>setLastname(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-3 md:col-span-1">
                              <label htmlFor="">
                                Gender <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <select name="" id="" className="" value={gender} onChange={(e)=>setGender(e.target.value)}>
                                  <option value="">
                                    Please choose gender...
                                  </option>
                                  <option value="male">
                                    Male
                                  </option>
                                  <option value="female">
                                    Female 
                                  </option>
                                </select>
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-3 md:col-span-1">
                              <label htmlFor="">
                                Email <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-3 md:col-span-1">
                              <label htmlFor="">
                                Contact <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <div className="relative rounded-md shadow-sm">
                                  <input type="number" value={mobile} onChange={(e)=>setMobile(e.target.value)} name="" id="" placeholder="" className="" required />
                                </div>
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-3 md:col-span-1">
                              <label htmlFor="">
                                DOB <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="date" value={dob} onChange={(e)=>setDob(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-2 sm:col-span-1 md:col-span-2">
                              <label htmlFor="">
                                 Address
                              </label>
                              <div className="mt-1">
                                <input type="text" value={address} onChange={(e)=>setAddress(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-2 md:col-span-1">
                              <label htmlFor="">
                                Staff Type
                              </label>
                              <div className="mt-1">
                                <select name="" id="" className="" value={staff_type} onChange={(e)=>setStaff_type(e.target.value)}>
                                  <option value="">
                                    Please choose Account...
                                  </option>
                                  <option value="contract">
                                    Contract
                                  </option>
                                  <option value="staff">
                                    Tutor
                                  </option>
                                </select>
                              </div>
                            </div>
                        
                            <div className="col-span-3 sm:col-span-1 md:col-span-3">
                                <div className='grid grid-cols-2 sm:grid-cols-2 gap-x-5 gap-y-4'>
                                    <div className="col-span-1 sm:col-span-2 md:col-span-1">
                                      <label htmlFor="">
                                        Join Date <span className="text-primary-600">*</span>
                                      </label>
                                      <div className="mt-1">
                                        <input type="date" value={joining_date} onChange={(e)=>setjoining_date(e.target.value)} name="" id="" placeholder="" className="" required />
                                      </div>
                                    </div>
                        
                                    <div className="col-span-1 sm:col-span-2 md:col-span-1">
                                    <label htmlFor="">
                                    Experties <span className="text-primary-600">*</span>
                                  </label>
                                  <div className="mt-1">
                                  <input type="text" value={experties} onChange={(e)=>setExperties(e.target.value)} name="" id="" placeholder="" className="" required />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='col-span-3 sm:col-span-1 md:col-span-3'>
                              <div className='grid grid-cols-4 sm:grid-cols-4 gap-x-5 gap-y-4'>
                                  <div className='col-span-1 sm:col-span-3 md:col-span-1'>
                                      <label htmlFor="phot">
                                        Upload Photo
                                      </label>
                                      <div className="mt-1">
                                        <input type="file" ref={inputRefPhoto} style={{display:"none"}} onChange={handleOnchange}/>
                                        <button className='file-btn' onClick={onChooseFile}>
                                            <MdOutlineFileUpload className='w-6 h-6'/>
                                            <span>Upload File</span>
                                        </button>
                                     
                                        {selectedPhoto && <div className='selected-file'>
                                            <p>{selectedPhoto.name}</p>
                                            <button onClick={removeFile}>
                                                <MdDelete />
                                            </button>
                                        </div>}
                                      </div>
                                  </div>
                                        
                                  <div className='col-span-1 sm:col-span-3 md:col-span-1'>
                                    <label htmlFor="">
                                      Upload Aadhar Id
                                    </label>
                                    <div className="mt-1">
                                      <input type="file" ref={inputRefAdhaar} style={{display:"none"}} onChange={handleOnchangeAdhaar}/>
                                      <button className='file-btn' onClick={onChooseAdhaar}>
                                          <MdOutlineFileUpload className='w-6 h-6'/>
                                          <span>Upload File</span>
                                      </button>
                                        
                                      {selectedAdhaar && <div className='selected-file'>
                                          <p>{selectedAdhaar.name}</p>
                                          <button onClick={removeAdhaar}>
                                              <MdDelete />
                                          </button>
                                      </div>}
                                    </div>
                                  </div>
                                      
                                  <div className='col-span-1 sm:col-span-3 md:col-span-1'>
                                    <label htmlFor="">
                                      Upload Pan Id
                                    </label>
                                    <div className="mt-1">
                                      <input type="file" ref={inputRefPan} style={{display:"none"}} onChange={handleOnchangePan}/>
                                      <button className='file-btn' onClick={onChoosePan}>
                                          <MdOutlineFileUpload className='w-6 h-6'/>
                                          <span>Upload File</span>
                                      </button>
                                      
                                      {selectedPan && <div className='selected-file'>
                                          <p>{selectedPan.name}</p>
                                          <button onClick={removePan}>
                                              <MdDelete />
                                          </button>
                                      </div>}
                                    </div>
                                  </div>
                                      
                                  <div className='col-span-1 sm:col-span-3 md:col-span-1'>
                                    <label htmlFor="">
                                      Upload Cancelled Cheque
                                    </label>
                                    <div className="mt-1">
                                      <input type="file" ref={inputRefCheque} style={{display:"none"}} onChange={handleOnchangeCheque}/>
                                      <button className='file-btn' onClick={onChooseCheque}>
                                          <MdOutlineFileUpload className='w-6 h-6'/>
                                          <span>Upload File</span>
                                      </button>
                                      
                                      {selectedCheque && <div className='selected-file'>
                                          <p>{selectedCheque.name}</p>
                                          <button onClick={removeCheque}>
                                              <MdDelete />
                                          </button>
                                      </div>}
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                      <div className="flex items-center justify-end mt-5 space-x-4">
                        <button type="button" className="btn btn-light" onClick={()=>navigate('/dashboard/staff/')}>
                          Back
                        </button>
    
                        <button type="submit" className="btn btn-primary">
                          Save & Next
                        </button>
                        </div>
                        </form>    
                      </div>
                    }
                    {
                      activeTab === 1 &&
                      <form action={(e)=>updateStaffTabTwo(e)}>
                          <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-5 gap-y-4">
                            <div className="col-span-1 sm:col-span-2 md:col-span-1">
                              <label htmlFor="">
                                Bank Name <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="text" value={bank_name} onChange={(e)=>setBank_name(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
    
                            <div className="col-span-1 sm:col-span-2 md:col-span-1">
                              <label htmlFor="">
                                Account Number <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="number" value={account_no} onChange={(e)=>setAccount_no(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-2 md:col-span-1">
                              <label htmlFor="">
                                Account Holder Name <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="text" value={account_holder_name} onChange={(e)=>setAccount_holder_name(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-2 md:col-span-1">
                              <label htmlFor="">
                                Account Type <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <select name="" id="" className="" value={accountType} onChange={(e)=>setAccountType(e.target.value)}>
                                  <option value="">
                                    Please choose Account...
                                  </option>
                                  <option value="savings">
                                    Savings
                                  </option>
                                  <option value="current">
                                    Current 
                                  </option>
                                </select>
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-2 md:col-span-1">
                              <label htmlFor="">
                                IFSC Code <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="text" value={ifsc_code} onChange={(e)=>setIfsc_code(e.target.value)} name="" id="" placeholder="" className="" required />
                              </div>
                            </div>
                        
                            <div className="col-span-1 sm:col-span-2 md:col-span-1">
                              <label htmlFor="">
                                Type of Salery <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <select name="" id="" className="" value={type_of_salary} onChange={(e)=>setType_of_salary(e.target.value)}>
                                  <option value="">
                                    Please choose Salery Type...
                                  </option>
                                  <option value="salarise">
                                    Salerise
                                  </option>
                                  <option value="contract">
                                    Contract
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                      <div className="flex items-center justify-end mt-5 space-x-4">
                        <button type="button" className="btn btn-light" onClick={()=>navigate('/dashboard/staff/')}>
                          Back
                        </button>
    
                        <button type="submit" className="btn btn-primary">
                          Save
                        </button>
                        </div>
                        </form>
                    }
                  </div>
                </div>
              </div>
          </div>
        </div>
  )
}

export default EditTutor
